import React from 'react'

type SectionBarProps = {
  borderColor?: string
  border?: string
  className?: React.ComponentProps<'div'>['className']
}

const SectionBar = ({ borderColor = 'border-020', border = 'border-[5px]', className = '' }: SectionBarProps) => {
  return <div className={`${border} ${className} w-full ${borderColor}`}></div>
}

export default SectionBar
